import store from '@/store';
import { ValidatorState } from '../types';
import { countryAcceptSellingCoins } from '../utils';
import { businessIsAllowedToSeeFeature } from '@/router/validators/utils/businessIsAllowedToSeeFeature';

export function sellCoinsValidator(): ValidatorState {
  let disclaimersKeys: Array<string> = [];
  const countryEnable = countryAcceptSellingCoins();
  const allowedToActivateSellCoins = businessIsAllowedToSeeFeature('physical');

  if (!countryEnable) {
    return {
      isValid: false,
      disclaimersKeys
    };
  }

  if (!allowedToActivateSellCoins) {
    return {
      isValid: false,
      disclaimersKeys
    };
  }

  const businessState = store.getters['business/getBusinessState'];

  if (!businessState) {
    return {
      isValid: false,
      disclaimersKeys
    };
  }

  return {
    isValid: true,
    disclaimersKeys
  };
}
